<template>
  <v-container grid-list-md fluid>
      <div v-html="insertedContent"></div>
  </v-container>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      default: ""
    },
    insertFields: {
      type: Array,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    insertedContent(){
      let tmp = this.content
      this.insertFields.forEach(item => {
        const reg = new RegExp('\\[\\['+ item.find +'\\]\\]', "g")
        tmp = tmp.replace(reg, item.replace)
      });
      return tmp
      
    }
  },
  methods: {}
};
</script>